// const API_BASE ='http://localhost:8080/api';
const API_BASE = process.env.REACT_APP_API_BASE_URL ;

export const apiFetch = async (url, options = {}) => {
  const headers = {
    // Don't set Content-Type for FormData - let browser set it with boundary
    ...options.headers,
  };

  // Add public user token if available
  const publicToken = localStorage.getItem("publicUserToken");
  if (publicToken) {
    headers["Authorization"] = `Bearer ${publicToken}`;
  }

  // Only set Content-Type for non-FormData requests
  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  const response = await fetch(`${API_BASE}${url}`, {
    ...options,
    headers,
    credentials: "include", // ✅ crucial for cookie-based auth (bureau)
  });

  if (response.status === 401) {
    // Only treat a 401 as a public-user session expiry if the request was
    // actually for a public-user-protected route. Otherwise (e.g. a bureau
    // endpoint that 401'd because the cookie expired) just clean up the
    // bureau visibility flag and throw — let the caller handle it. This
    // prevents an infinite redirect loop where:
    //   1. BureauPrivateRoute calls /auth/profile and gets 401.
    //   2. The old code did window.location.href = "/" and wiped the
    //      public token.
    //   3. The new tab loaded "/", auto-redirect saw bureauActive=true,
    //      sent the user back to /bureau/dashboard, failing /auth/profile
    //      again, and so on forever.
    const isPublicEndpoint =
      url.startsWith("/public/") || url.startsWith("/referrals/client");

    if (isPublicEndpoint) {
      localStorage.removeItem("publicUserToken");
      window.location.href = "/";
      return;
    }

    // Bureau auth endpoint 401 — clear the stale visibility flag so the
    // auto-redirect hook stops claiming the bureau is logged in.
    if (url.startsWith("/auth/")) {
      try { localStorage.removeItem("bureauActive"); } catch { /* */ }
    }
    // Fall through to throw the error normally below.
  }

  let payload = null;
  const hasBody = response.status !== 204;

  if (hasBody) {
    try {
      payload = await response.json();
    } catch (error) {
      console.error("Failed to parse JSON response:", error);
    }
  }

  if (!response.ok) {
    const errorMessage =
      payload?.message || payload?.error || "Something went wrong";
    const err = new Error(errorMessage);
    // Attach the raw status + payload so callers can react to specific
    // conditions (e.g. 409 conflict carrying the latest doc).
    err.status = response.status;
    err.payload = payload;
    throw err;
  }

  return payload;
};
